<template>
    <b-card :header-class="'alert-' + variant" :bg-variant="variant" text-variant="light" class="text-center">
        <div slot="header">
            <h6 style="white-space:nowrap;">Индивидуальный лактатный порог</h6>
        </div>
        <b-card-text>
            <h6>{{ Math.abs(coeff).toFixed(0) }} уд/мин</h6>
            <h6>{{ msg }}</h6>
        </b-card-text>
    </b-card>
</template>

<script>
    import _ from "lodash";

    export default {
        props: {
            coeff: {
                type: Number,
                default: 0,
            }
        },
        computed: {
            msg: function () {
                return this.find().msg;
            },
            variant: function () {
                return this.find().variant;
            },
        },
        data() {
            return {
                display: [
                    {
                        is: function (x) {
                            return x >= 171;
                        },
                        msg: 'Отлично',
                        variant: 'success'
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 161, 171);
                        },
                        msg: 'Хорошо',
                        variant: 'warning'
                    },
                    {
                        is: function (x) {
                            return _.inRange(x, 151, 161);
                        },
                        msg: 'Удовлетворительно',
                        variant: 'primary'
                    },
                    {
                        is: function (x) {
                            return x < 151;
                        },
                        msg: 'Неудовлетворительно',
                        variant: 'danger'
                    }
                ]
            }
        },
        methods: {
            find() {
                let vm = this;
                return _.find(this.display, function (d) {
                    return d.is(vm.coeff);
                });
            }
        }
    }
</script>